import React from "react";
import { API } from "aws-amplify";

// ReportRecord interface should include an 'id' property, along with path and generation_date.
export interface ReportRecord {
  path: string;
  report_data_date: string;
  generation_date: string;
}

interface DownloadReportProps {
  record: ReportRecord;
}

const DownloadReport: React.FC<DownloadReportProps> = ({ record }) => {
  const handleDownload = async () => {
    try {
      // Use record.path as is to keep the URL-encoded characters intact (e.g. '%2F')
      const response = await API.get(
        "TrustAPI",
        `cost/report/download/${record.path}`,
        {},
      );

      // The integration returns a 307 status with the Location header containing the pre-signed URL.
      if (
        response.statusCode === 307 &&
        response.headers &&
        response.headers.Location
      ) {
        window.open(response.headers.Location, "_blank");
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error downloading report:", error);
    }
  };

  return <button onClick={handleDownload}>Download</button>;
};

export default DownloadReport;
